const TABLE_CELL_COMPONENT = 'tablecell';
const FORM_FIELD_COMPONENT = 'formfield';
const NOT_APPLICABLE = 'N/A';

const modeIndex = edit => (edit ? 0 : 1);

class Editor {
  constructor(name, components) {
    this.name = name;
    this.components = components;
  }

  getComponent(type, edit) {
    return this.components[type] && this.components[type][modeIndex(edit)];
  }

  getTableCellComponent(edit) {
    return this.components[TABLE_CELL_COMPONENT][modeIndex(edit)];
  }

  setComponent(type, component, edit) {
    let compModes = this.components[type];
    if (!compModes) {
      compModes = [];
      this.components[type] = compModes;
    }
    compModes[modeIndex(edit)] = component;
  }

  formatValue(value /* , data, propName, props */) {
    return value;
  }

  getFilterValue(value, formattedValue) {
    return formattedValue;
  }

  getSortValue(value /* ,formattedValue, props */) {
    return value;
  }
}

export { Editor as default, TABLE_CELL_COMPONENT, FORM_FIELD_COMPONENT, NOT_APPLICABLE };
